import { useAccountStore } from '../stores';

export const fetchWrapper = {
    get: request('GET'),
    post: request('POST'),
    put: request('PUT'),
    delete: request('DELETE')
};

function request(method) {
    return (url, body) => {
        const requestOptions = {
            method,
            headers: authHeader(url)
        };
        if (body) {
            if(body.constructor.name==='FormData'){
                requestOptions.body = body;
            }
            else{
                requestOptions.headers['Content-Type'] = 'application/json';
                requestOptions.body = JSON.stringify(body);
            }
        }
        return fetch(url, requestOptions).then(handleResponse);
    }
}

// helper functions

function authHeader(url) {
    // return auth header with jwt if user is logged in and request is to the api url
    const { user } = useAccountStore();
    const isLoggedIn = !!user?.accessToken;
    const isApiUrl = url.startsWith(process.env.VUE_APP_VUE_API_URL);
    if (isLoggedIn && isApiUrl) {
        return { 'x-access-token': `${user.accessToken}` };
    } else {
        return {};
    }
}

async function handleResponse(response) {
    const isJson = response.headers?.get('content-type')?.includes('application/json');
    const data = isJson ? await response.json() : null;

    // check for error response
    if (!response.ok) {
        const { user, signout } = useAccountStore();
        if ([401, 403].includes(response.status) && user) {
            signout();
        }
        // get error message from body or default to response status
        const error = (data && data.message) || response.status;
        return Promise.reject(error);
    }

    return data;
}
